import React from "react";
import { Flex, Image, Text, Tooltip } from "@chakra-ui/react";

type ShowBenchmarkProps = {
	benchmark: number;
};
/**
 * Creates type of card used for the events
 *
 * @constructor
 */
export const ShowBenchmark = ({ benchmark }: ShowBenchmarkProps) => {
	const labelTooltip =
		`This benchmark number is a score relative to the average performance 
		of your published Foleon documents. Below a hundred means less performance
		than average and above a hundred means better than average.`;

	const getCorrectMeterImage = () => {
		const AVERAGE_GRADING = 80;
		const EQUAL_GRADING = 100;
		if (benchmark < AVERAGE_GRADING)
			return "meter_red.svg";
		else if (benchmark >= AVERAGE_GRADING && benchmark < EQUAL_GRADING)
			return "meter_orange.svg";
		else return "meter_green.svg";
	};
	return (
		<Tooltip label={labelTooltip}>
			<Flex fontSize="40px" alignItems="center" mt="10px" mb="-25px !important" gap="16px"
				  direction="row-reverse">
				<Text>{benchmark}</Text>
				<Image
					w="36px"
					h="36px"
					src={process.env.PUBLIC_URL + `/Analytics/${getCorrectMeterImage()}`}
				/>
			</Flex>
		</Tooltip>
	);
};

export default ShowBenchmark;
